import { styled } from '../jss-style';
import stepsStyle from './steps';

const useStepsStyle = styled(stepsStyle, 'steps');
export { stepsStyle, useStepsStyle };
export default useStepsStyle;
